import { useState } from "react";

export interface RoundedTabGroupProps {
    children: React.ReactElement<RoundedTabProps>[];
    defaultTabName?: string;
    className?: string;
    tabGroupClassName?: string;
    onClick: (tabName: string) => void;
}

export function RoundedTabGroup(props: RoundedTabGroupProps) {
    const [selectedPage, setSelectedPage] = useState<string>(props.defaultTabName ?? "");
    return (
        
        <>
        <div className={props.className}>
            <div className={`inline-flex rounded-full shadow-sm bg-white ${props.tabGroupClassName}`} role="group">
                {props.children.map((tabItem, index) =>
                    <button type="button" className={"btn px-4 py-2 text-sm font-semibold rounded-full hover:opacity-80 focus:z-10 " +
                        (selectedPage === tabItem.props.name ? "bg-mk-primary-bright text-white shadow-md" : "bg-white text-mk-very-dark-grey btn-secondary border-none")}
                        onClick={() => {setSelectedPage(tabItem.props.name);props.onClick(tabItem.props.name)}} key={index}>
                        {tabItem.props.title}
                    </button>
                )}
            </div>
        </div>
        {
                props.children.map((tabItem, index) =>
                    <div key={index}>
                        {selectedPage === tabItem.props.name && tabItem.props.children}
                    </div>
                )
        }
        </>
    );
}

export interface RoundedTabProps {
    name: string;
    title: string;
    children: React.ReactNode;
}

export function RoundedTab(props: RoundedTabProps) {
    return (<div>{props.children}</div>);
}
